import { inject } from "@angular/core"
import { Routes } from "@angular/router"
import { catchError, map, of, switchMap } from "rxjs"

import { ApiAuthGuard, ApiAuthService, ApiUserModel,ApiUserModelRoleEnum  } from "@logick/core-api"
import { withNavRoutes } from "@logick/ui/config"

import { ForgotPasswordPage, PasswordValidationPage, UserLoginPage } from "@/core/auth"
import { CriticalErrorPage } from "@/core/error/critical-error"
import { MainLayout } from "@/core/main-layout"
import { PartnerApiService } from "@/features/admin/partners/services/partners-api.service"
import { APP_MENU, getDefaultPartnerRoute } from "./app.menu"


export const routes: Routes = [
  { path: "login", component: UserLoginPage },
  { path: "forgot-password", component: ForgotPasswordPage },
  { path: "password-validation", component: PasswordValidationPage },
  { path: "error", component: CriticalErrorPage },
  {
    path: "", component: MainLayout,
    canMatch: [ApiAuthGuard],
    canActivateChild: [ApiAuthGuard],
    children: [
      {
        path: "", pathMatch: "full", redirectTo: () => {
          const authService = inject(ApiAuthService)
          const partnerApiService = inject(PartnerApiService)

          return authService.connectedUser().pipe(switchMap((u: ApiUserModel) => {
            if (u.role !== ApiUserModelRoleEnum.Partner) {
              return of("/dashboard")
            }

            return partnerApiService.getPartnerById(u.organization.id).pipe(
              map(partner => getDefaultPartnerRoute(partner.catalogScope)),
              catchError(() => of("/catalog"))
            )
          }))
        }
      },
      ...withNavRoutes(APP_MENU),
    ]
  }
]
